module.exports = __webpack_public_path__ + "static/img/introimg.3becf40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/introimg.png
// module id = EcPh
// module chunks = 0